import { render, staticRenderFns } from "./dialog-related.vue?vue&type=template&id=61056028"
import script from "./dialog-related.vue?vue&type=script&lang=js"
export * from "./dialog-related.vue?vue&type=script&lang=js"
import style0 from "./dialog-related.vue?vue&type=style&index=0&id=61056028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports